import { useMemo } from 'react';

import { createPermissionCheckers } from 'src/permissions/permission-engine';

import type { PermissionsMap } from './permission-utils';

export function usePermissionChecks(permissions: PermissionsMap | null, userRole?: string | null) {
  return useMemo(
    () => createPermissionCheckers(permissions, userRole ?? null),
    [permissions, userRole]
  );
}
